import React from 'react'

import ProductPageWrapper from '../../../react4xp/components/ProductPageWrapper'

function ProductLayout({ bgColor, isWhite, title, intro, image, sectionStores, allergens, tracesOf, strings, ingredients, nutritionFacts }) {
    return (
        <ProductPageWrapper
            topPart={{
                bgColor: bgColor,
                whiteText: isWhite,
                image: {
                    src: image?.src,
                    srcMedium: image?.srcMedium,
                    alt: image?.alt
                },
                title: title,
                desc: intro
            }}
            nutritionFacts={nutritionFacts.map(nutritionFact => {
                return {
                    sectionTitle: nutritionFact.title,
                    items: nutritionFact.rows.map(row => {
                        return {
                            title: row.text,
                            value: row.value
                        }
                    })
                }
            })}
            ingredients={{
                sectionTitle: strings.ingredientsHeader,
                content: ingredients
            }}
            allergens={{
                allergensTitle: strings.allergensHeader,
                allergensItems: allergens,
                tracesOfTitle: strings.tracesOfHeader,
                tracesOfItems: tracesOf
            }}
            shops={{
                sectionTitle: strings.shopsHeader,
                stores: sectionStores.map(store => {
                    return {
                        title: store.title,
                        storeAt: {
                            title: strings.storeAtHeader,
                            items: store.storeAt
                        },
                        productAt: {
                            title: strings.productAtHeader,
                            items: store.productAt
                        }
                    }
                })
            }}
        />
    )
}

export default (props) => <ProductLayout {...props} />
